import React from 'react';
import dayjs from 'dayjs';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { useSnackbar } from 'notistack';

import { useDispatch } from 'react-redux';
import * as employeeApi from '../../../lib/api/employee';
import { listCounsel } from '../../../modules/empModule/empResume';
import CounselFormDialog from '../../../components/employeemng/resume/CounselFormDialog';

const CounselFormContainer = ({ employee, type, data, open, handleClose }) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  
  //console.log(data,'data');


  const initialValues = {
    attrVal1: data && data.attrVal1 !== undefined ? data.attrVal1 : '',
    attrVal2: data && data.attrVal2 !== undefined ? data.attrVal2 : '',
    attrVal3: data && data.attrVal3 !== undefined ? data.attrVal3 : '',
  };


  const validationSchema = yup.object({
    attrVal1: yup.string('').required('종류를 입력하세요'),
    attrVal2: yup.string().required('면담내용을 입력하세요'),
    attrVal3: yup.date().required('등록일자를 입력하세요'),
  });

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true);

      let dataToSubmit = {
        usrUuid: employee.usrUuid,
        infoTyp: 'COUNSEL',
        attrVal1: values.attrVal1,
        attrVal2: values.attrVal2,
        attrVal3: values.attrVal3
          ? dayjs(values.attrVal3).format('YYYY-MM-DD')
          : dayjs(new Date()).format('YYYY-MM-DD'),
      };

      //console.log(JSON.stringify(dataToSubmit),'dataToSubmit');

      onSave(dataToSubmit);
      onClose();
      //formik.resetForm();
      setSubmitting(false);
    },
  });

  const onSave = async (dataToSubmit) => {
    if (type === 'add') {
      try {
        const response = await employeeApi.addResumeByEmp(dataToSubmit);
        if (response.data) {
          dispatch(
            listCounsel({
              id: employee.usrUuid,
              infoTyp: 'COUNSEL',
            }),
          );
        }
      } catch (err) {
        let message =
          typeof err.response !== 'undefined'
            ? err.response.data.message
            : err.message;
        enqueueSnackbar(message, {
          variant: 'error',
        });
      }
    } else {
      try {
        dataToSubmit.infoUuid = data.infoUuid;

        console.log(dataToSubmit,'dataToSubmit');

        const response = await employeeApi.editResumeByEmp(dataToSubmit);
        if (response.data) {
          dispatch(
            listCounsel({
              id: employee.usrUuid,
              infoTyp: 'COUNSEL',
            }),
          );
        }
      } catch (err) {
        let message =
          typeof err.response !== 'undefined'
            ? err.response.data.message
            : err.message;
        enqueueSnackbar(message, {
          variant: 'error',
        });
      }
    }
  }

  const onClose = () => {
    formik.resetForm();
    handleClose();
  };


  return <CounselFormDialog
    type={type}
    open={open}
    handleClose={onClose}
    formik={formik} />;
};

export default CounselFormContainer;
